import { Card, CardContent } from "@babackapp/ui/components/card";
import PremiumFeatureBadge from "@babackapp/ui/components/premium-feature-badge";
import { cn } from "@babackapp/ui/lib/utils";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { LogisticianOptionsForm } from "./logistician-options-form";
import ShopSettingsWorkflowForm from "./shop-settings-workflow-form";

export default function WorkflowLogisiticianCard() {
  const { data: shop } = useCurrentShopSuspense();

  const disabled = false && !shop.plan.workflowLogistician;

  return (
    <Card className="w-full">
      <CardContent className="mt-4 flex-col flex gap-4 px-4">
        <div
          className={cn(
            "rounded-md flex justify-between flex-1 p-4",
            disabled && "bg-[#ffa73209]",
          )}
        >
          <div className="flex flex-col flex-1 gap-8">
            <ShopSettingsWorkflowForm />
            <LogisticianOptionsForm />
          </div>

          {disabled && <PremiumFeatureBadge />}
        </div>
      </CardContent>
    </Card>
  );
}
